import axios from "axios";
import DebugService from "./DebugService";

/**
 * @description Chat PDF Us Api Service
 */
const ChatPDFApiService = {
  /**
   * Upload PDF
   * @param {*} data 
   * @returns 
   */
  uploadPDF: async (data) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_CHATBOT_API_BASE_URL}/upload-pdf/`, data);

      if (response.status !== 200) {
        throw new Error ('Caught error while upload PDF', response, data)
      }

      return response.data;
    } catch (error) {
      DebugService.error(`Chat PDF API Service: Error caught while upload PDF`, error, data);
      throw error;
    }
  },
  
  /**
   * Post Question
   * @param {*} data 
   * @returns 
   */
  postQuestion: async (data) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_CHATBOT_API_BASE_URL}/ask-question/`, data);

      if (response.status !== 200) {
        throw new Error ('Caught error while posting question', response, data)
      }

      return response.data;
    } catch (error) {
      DebugService.error(`Chat PDF API Service: Error caught while posting question`, error, data);
      throw error;
    }
  },

  
};

export default ChatPDFApiService;
